/**
 * The base-30 digits of identifiers people read aloud or type: tenants
 * ([ADR-0016](../../../docs/decisions/0016-tenant-identifier-scheme.md)) and
 * genuine incidents ([ADR-0085](../../../docs/decisions/0085-incident-identifiers-from-the-first-call.md)).
 * Crockford's base-32 without `0` and `1`, which operators hesitated over in VIDIs.
 */
const ALPHABET = "23456789ABCDEFGHJKMNPQRSTVWXYZ";
const BASE = ALPHABET.length;

export const Base30 = {
  /** `n` in base-30, left-padded with the zero digit `2` to `width`. */
  encode: (n: number, width: number): string => {
    if (!Number.isSafeInteger(n) || n < 0) throw new RangeError(`Cannot encode ${String(n)} as base-30.`);
    let digits = "";
    for (let remaining = n; remaining > 0; remaining = Math.floor(remaining / BASE)) {
      digits = ALPHABET.charAt(remaining % BASE) + digits;
    }
    if (digits.length > width) {
      throw new RangeError(`${String(n)} needs more than ${String(width)} base-30 digits.`);
    }
    return digits.padStart(width, ALPHABET.charAt(0));
  },

  /** The number `digits` spell, or `undefined` when one of them is not a base-30 digit. */
  decode: (digits: string): number | undefined => {
    let n = 0;
    for (const digit of digits) {
      const value = ALPHABET.indexOf(digit);
      if (value === -1) return undefined;
      n = n * BASE + value;
    }
    return n;
  },
} as const;
